import { useCallback, useEffect, useState } from 'react';
import { WarehouseInventoryProductsService } from '../../../api/services/WarehouseInventoryProductsService';
import { InventoryBlockHistoryEntry } from '../../../types/inventory-block-history.types';

export interface UseInventoryBlockHistoryParams {
  open: boolean;
  warehouseProductId?: number;
  refreshKey?: number;
}

export function useInventoryBlockHistory({
  open,
  warehouseProductId,
  refreshKey,
}: UseInventoryBlockHistoryParams) {
  const [entries, setEntries] = useState<InventoryBlockHistoryEntry[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchHistory = useCallback(async () => {
    if (warehouseProductId == null) {
      setEntries([]);
      setError(null);
      return;
    }

    setIsLoading(true);
    setError(null);
    try {
      const response =
        await WarehouseInventoryProductsService.warehouseInventoryProductsControllerGetBlockHistory(
          warehouseProductId,
        );
      setEntries(response?.data ?? []);
    } catch (err: unknown) {
      const message =
        err && typeof err === 'object' && 'body' in err
          ? (err as { body?: { message?: string } }).body?.message
          : undefined;
      setError(message ?? 'No se pudo cargar el historial de bloqueos y bajas');
      setEntries([]);
    } finally {
      setIsLoading(false);
    }
  }, [warehouseProductId]);

  useEffect(() => {
    if (!open) {
      return;
    }
    void fetchHistory();
  }, [open, fetchHistory, refreshKey]);

  return { entries, isLoading, error, refetch: fetchHistory };
}
